import routerOptions0 from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@20.14.9_@vue+compiler-sfc@3.5.44_cac@6.7._4nw34muufof73viqpe4o44xswm/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/web/wap/releases/20261105-112808-9a5c5696/vue_src/nuxt/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}